import React, { Component } from 'react';
import i18next from 'i18next'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class ServiceConnectionStatus extends Component {

	render() {
		return (
			<div>
				{
					this.props.connectionStatus.status 
					? <div className="serviceConnected" id="serviceConnectionStatus" style={{"padding": "10px"}}>
				        {i18next.t("serviceConnected" : "serviceConnected")}
			        </div>
			        : <div className="serviceDisconnected" id="serviceConnectionStatus" style={{"padding": "10px"}}>
				        {i18next.t("serviceNotConnected" : "serviceNotConnected")}
			        </div>
				}
			</div>
			
	    );
	}
}

function mapStateToProps(state) {
    return {
    	localesReducer: state.localesReducer,
        language: state.localesReducer.language,
    	baseUrls: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceConnectionStatus);


// WEBPACK FOOTER //
// ./src/components/header/ServiceConnectionStatus.js